import axios from 'axios';

// Produção continua sendo o padrão; REACT_APP_APOLLO_URL existe para apontar o
// portal a uma Apolo local durante o desenvolvimento.
const apolloAuth = axios.create({
  baseURL: process.env.REACT_APP_APOLLO_URL || 'https://apolo.duelaser.com/api',
});

const ApolloAuth = {
  async login({ email, password }) {
    const { data } = await apolloAuth.post('/auth/login', { email, password });
    return data;
  },

  /**
   * O cadastro é feito direto no Apolo, que é dono da conta e da senha. O
   * `metadata` viaja fechado: indicação e tipo de usuário só interessam a quem
   * consome o evento do outro lado.
   */
  async register(payload) {
    const { data } = await apolloAuth.post('/auth/register', payload);
    return data;
  },

  async resendVerification({ email }) {
    const { data } = await apolloAuth.post('/auth/resend-verification', {
      email,
    });
    return data;
  },

  async refresh({ refreshToken }) {
    const { data } = await apolloAuth.post('/auth/refresh', { refreshToken });
    return data;
  },

  async logout({ refreshToken }) {
    await apolloAuth.post('/auth/logout', { refreshToken });
  },

  async forgotPassword({ email }) {
    const { data } = await apolloAuth.post('/auth/forgot-password', { email });
    return data;
  },

  async verifyPassword({ token, password }) {
    await apolloAuth.post(
      '/auth/verify-password',
      { password },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
};

export default ApolloAuth;
